// Acquisition economics — app-account CAC and card activation cost.

export function blendedAppAccountCac(inputs) {
  const entries = Object.values(inputs.channelMix || {});
  return entries.reduce((sum, c) => sum + (c.weight ?? 0) * (c.cpa ?? 0), 0);
}

export function cardActivationCost(inputs, newCardholdersByTier) {
  const costs = inputs.acquisition?.cardActivationCost || {};
  return Object.entries(newCardholdersByTier || {}).reduce(
    (sum, [tierKey, count]) => sum + count * (costs[tierKey] ?? 0),
    0,
  );
}
